module.exports = __webpack_public_path__ + "static/media/scan_qrcode.672cd7d7.jpg";